import { TFunction } from '@mint-lib/i18n';

export const Columns = {
  EXPANDER: 'name',
  ACTIONS_MENU: 'actionsMenu',
  OBJECTIVE: 'objective',
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
  PRIMARY_GOAL: 'primaryGoal',
  BUDGET: 'budget',
  LABEL: 'label',
  MASK: 'mask',
  TOTAL: 'total',
  PARTNER: 'partner',
  CHANNEL_MIX_BUDGET: 'channelMixBudget',
  PLATFORM_MEDIA: 'platformMedia',
  CALCULATED_IMPRESSIONS: 'calculatedImpressions',
  CALCULATED_CLICKS: 'calculatedClicks',
  CALCULATED_CONVERSIONS: 'calculatedConversions',
  CALCULATED_VIDEO_VIEWS: 'calculatedVideoViews',
  CALCULATED_LEADS: 'calculatedLeads',
  CALCULATED_SESSIONS: 'calculatedSessions',
  CALCULATED_EATP: 'calculatedEatp',
  CALCULATED_EROI: 'calculatedEroi',
  CALCULATED_ECPS: 'calculatedEcps',
  CALCULATED_ECPV: 'calculatedEcpv',
  CALCULATED_ECPA_ANALYTICS: 'calculatedEcpaAnalytics',
  CALCULATED_CONVERSIONS_ANALYTICS: 'calculatedConversionsAnalytics',
  REVENUE: 'revenue',
  CONNECT_RATE: 'connectRate',
  FUNNEL_STRATEGY: 'funnelStrategy',
  ITEM_GOAL: 'itemGoal',
  CO2: 'estimatedCo2CostKg',
  CO2_OFFSET: 'estimatedCo2CostOffset',
  ACTIVE_DAYS: 'activeDays',
  VAT: 'vat',
  ADSERVER_COST: 'adserverCost',
  OPTIMAL_BUDGET: 'optimalBudget',
  EXPECTED_CPC: 'expectedCpc',
  EXPECTED_CPM: 'expectedCpm',
  COST_PER_METRIC: 'costPerMetric',
  IO_ID: 'ioId',
  IO_STATUS: 'ioStatus',
  DEVICE: 'device',
  VIEWS: 'expectedViews',
  PERCENT_SESSIONS: 'percentSessions',
  TOTAL_CAMPAIGN_REVENUE: 'totalCampaignRevenue',
  PLATFORM_SHARE: 'platformShare',
  CALCULATED_SESSIONS_BY_PERCENT: 'calculatedSessionsByPercent',
  CALCULATED_CONVERSIONS_BY_SESSION: 'calculatedConversionsBySession',
  CALCULATED_REVENUE_BY_PLATFORM_SHARE: 'calculatedRevenueByPlatformShare',
  PERCENT_NEW_USERS: 'percentNewUsers',
  PERCENT_REGISTRATION: 'percentRegistration',
  PERCENT_FREE_TRIALS: 'percentFreeTrials',
  PERCENT_FIRST_PAID_SUBSCRIPTIONS_FT: 'percentFirstPaidSubscriptionsFt',
  PERCENT_FIRST_PAID_SUBSCRIPTIONS_EX_FT: 'percentFirstPaidSubscriptionsExFt',
  PERCENT_RESUBSCRIPTIONS_FT: 'percentResubscriptionsFt',
  PERCENT_RESUBSCRIPTIONS_EX_FT: 'percentResubscriptionsExFt',
  CALCULATED_NEW_USERS: 'calculatedNewUsers',
  CALCULATED_REGISTRATIONS: 'calculatedRegistrations',
  CALCULATED_FREE_TRIALS: 'calculatedFreeTrials',
  CALCULATED_FIRST_PAID_SUBSCRIPTIONS_FT: 'calculatedFirstPaidSubscriptionsFt',
  CALCULATED_FIRST_PAID_SUBSCRIPTIONS_EX_FT:
    'calculatedFirstPaidSubscriptionsExFt',
  CALCULATED_RESUBSCRIPTIONS_FT: 'calculatedResubscriptionsFt',
  CALCULATED_RESUBSCRIPTIONS_EX_FT: 'calculatedResubscriptionsExFt',
  CALCULATED_TOTAL_SUBSCRIPTIONS: 'calculatedTotalSubscriptions',
  PERCENT_AGENCY_COMMISSION: 'percentAgencyCommission',
  YOUGOV_FEE: 'yougovFee',
  CALCULATED_AGENCY_COMMISSION: 'calculatedAgencyCommission',
  CALCULATED_ASBOF: 'calculatedAsbof',
  CALCULATED_CLIENT_COST: 'calculatedClientCost',
  PRODUCTION_FEE: 'productionFee',
  VERIFICATION_FEE: 'verificationFee',
};

export const beyondWayColumnsUnderFf = [
  Columns.PERCENT_AGENCY_COMMISSION,
  Columns.YOUGOV_FEE,
  Columns.CALCULATED_AGENCY_COMMISSION,
  Columns.CALCULATED_ASBOF,
  Columns.CALCULATED_CLIENT_COST,
];

export const beyondWayColumnsUnderFfPart2 = [
  Columns.PRODUCTION_FEE,
  Columns.VERIFICATION_FEE,
];

export const predictiveColumns = [
  Columns.OPTIMAL_BUDGET,
  Columns.COST_PER_METRIC,
];

export const kpiCostPerMetricsToMap = {
  impressions: Columns.EXPECTED_CPM,
  clicks: Columns.EXPECTED_CPC,
  views: Columns.VIEWS,
  default: Columns.COST_PER_METRIC,
};

export const dragItemTypes = {
  HEADER: 'HEADER',
  EXIST_HEADER: 'EXIST_HEADER',
  ADD_ROW: 'ADD_ROW',
  ADD_TILE: 'ADD_TILE',
};

export const getTooltipMessage = (t: TFunction) => ({
  CO2: t(
    'This value is an estimate. The actual emissions will be calculated based on your final metrics.',
  ),
  CO2_OFFSET: t(
    'This value is an estimate. The actual cost for the offset will be calculated based on your final metrics.',
  ),
  CO2_NO_ACCESS: t("You don't have the permissions to perform this action"),
  CO2_FULL_ACCESS: t(
    'Activate the Carbon Offset feature at no cost to offset the carbon emissions of the buying plan',
  ),
});

export const PORTAL_CONTAINER = 'dialog-portal';
export const LAST_ACTIVE_ROW_MESSAGE =
  "Can not set 'None'. This is the last active row.";
export const EMPTY_CELL_ERROR = "This column cell can't be empty";
